<section fxLayout="column" fxLayoutAlign="center center" fxFlex>
  <mat-progress-spinner
    [strokeWidth]="2"
    [color]="progressSpinnerColor"
    [diameter]="30"
    mode="indeterminate">
  </mat-progress-spinner>
  <small [innerHTML]="'Loading: ' + progressSpinnerText"></small>
</section>
